import {
  FeatureFlags,
} from '../../analytics/posthog'
import {
  type ExperimentArm,
  type ExperimentAssignment,
  useFirstPaintArm,
} from '../../hooks/useFirstPaintArm'

export type PermissionsCopyArm = ExperimentArm
export type PermissionsCopyAssignment = ExperimentAssignment

// The permissions-step copy experiment (GET-19510). This is the funnel's
// leakiest screen, so it is decided on first paint and never waited for. The
// step comes after sign-in and a channel connect, so almost everyone reaching
// it already has their flags.
export function usePermissionsCopyArm(): PermissionsCopyAssignment {
  return useFirstPaintArm(FeatureFlags.PERMISSIONS_STEP_COPY)
}
